import React, { useState, useCallback } from 'react';

const useFullScreen =  ()=> {
    const [isFullscreen, setIsFullscreen] = useState(false);

    const toggleFullScreen = useCallback(() => {
        const element = document.documentElement;

        if (document.fullscreenElement) {
            // Si nous sommes déjà en mode plein écran, sortir du mode plein écran
            if (document.exitFullscreen) {
                document.exitFullscreen();
            } else if (document.mozCancelFullScreen) {
                document.mozCancelFullScreen();
            } else if (document.webkitExitFullscreen) {
                document.webkitExitFullscreen();
            } else if (document.msExitFullscreen) {
                document.msExitFullscreen();
            }
            setIsFullscreen(false);
        } else {
            // Si nous ne sommes pas encore en mode plein écran, demander au navigateur d'entrer en mode plein écran
            if (element.requestFullscreen) {
                element.requestFullscreen();
            } else if (element.mozRequestFullScreen) {
                element.mozRequestFullScreen();
            } else if (element.webkitRequestFullscreen) {
                element.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
            } else if (element.msRequestFullscreen) {
                element.msRequestFullscreen();
            }
            setIsFullscreen(true);
        }
    }, []);

    return { isFullscreen, toggleFullScreen };
}

export default useFullScreen
